// src/context/CartContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
const [cart, setCart] = useState(() => {
  const storedCart = localStorage.getItem("cart");
  return storedCart ? JSON.parse(storedCart) : [];
});

useEffect(() => {
  localStorage.setItem("cart", JSON.stringify(cart));
}, [cart]);

const increaseQuantity = (id) => {
setCart(prev =>
prev.map(item =>
item._id === id ? { ...item, quantity: item.quantity + 1 } : item
)
);
};

const decreaseQuantity = (id) => {
setCart(prev =>
prev.map(item =>
item._id === id && item.quantity > 1
? { ...item, quantity: item.quantity - 1 }
: item
)
);
};

const removeFromCart = (id) => {
  setCart(prev => prev.filter(item => item._id !== id));
};

const addToCart = (item) => {
  setCart(prev => {
    const existing = prev.find(i => i._id === item._id);
    if (existing) {
      return prev.map(i =>
        i._id === item._id ? { ...i, quantity: i.quantity + 1 } : i
      );
    } else {
      return [...prev, { ...item, quantity: 1 }];
    }
  });
};

return (
  <CartContext.Provider
    value={{
      cart,
      cartItems: cart,
      increaseQuantity,
      decreaseQuantity,
      removeFromCart,
      addToCart,
      setCart,
    }}
  >
    {children}
  </CartContext.Provider>
);
};






